import { render, staticRenderFns } from "./ReviewOrders.vue?vue&type=template&id=4eeefa30"
import script from "./ReviewOrders.vue?vue&type=script&lang=js"
export * from "./ReviewOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports